__turbopack_context__.v({
  "button": "breedPawPrints-module-scss-module__S2pdNG__button",
  "buttonNext": "breedPawPrints-module-scss-module__S2pdNG__buttonNext",
  "buttonPrev": "breedPawPrints-module-scss-module__S2pdNG__buttonPrev",
  "carousel": "breedPawPrints-module-scss-module__S2pdNG__carousel",
  "content": "breedPawPrints-module-scss-module__S2pdNG__content",
  "date": "breedPawPrints-module-scss-module__S2pdNG__date",
  "dot": "breedPawPrints-module-scss-module__S2pdNG__dot",
  "dotActive": "breedPawPrints-module-scss-module__S2pdNG__dotActive",
  "dots": "breedPawPrints-module-scss-module__S2pdNG__dots",
  "header": "breedPawPrints-module-scss-module__S2pdNG__header",
  "image": "breedPawPrints-module-scss-module__S2pdNG__image",
  "info": "breedPawPrints-module-scss-module__S2pdNG__info",
  "item": "breedPawPrints-module-scss-module__S2pdNG__item",
  "name": "breedPawPrints-module-scss-module__S2pdNG__name",
  "parentTitle": "breedPawPrints-module-scss-module__S2pdNG__parentTitle",
  "pawPrints": "breedPawPrints-module-scss-module__S2pdNG__pawPrints",
  "title": "breedPawPrints-module-scss-module__S2pdNG__title",
});
